import type { AppRouteModule } from '/@/router/types';
import { MATERIAL_ABILITY } from '/@/enums/common-editor';

const batch: AppRouteModule = {
  path: '/batch',
  name: 'Batch',
  redirect: '/batch/dashboard',
  component: () => import('/@/layouts/batch/index.vue'),
  meta: {},
  children: [
    {
      path: '/batch/dashboard',
      name: 'BatchDashboard',
      meta: {
        title: '工作台',
      },
      component: () => import('/@/views/batch/dashboard/index.vue'),
    },
    {
      path: '/batch/cases',
      name: 'BatchCases',
      meta: {
        title: '案例中心',
      },
      component: () => import('/@/views/batch/cases/index.vue'),
    },
    {
      path: '/batch/my-space',
      name: 'BatchMyspace',
      meta: {
        title: '我的空间',
      },
      component: () => import('/@/views/batch/my-space/index.vue'),
    },
    {
      path: '/batch/my-space/trash',
      name: 'BatchTrash',
      meta: {
        title: '回收站',
      },
      component: () => import('/@/views/batch/my-space/trash.vue'),
    },
    {
      path: '/batch/my-space/auto-clean',
      name: 'BatchAutoClean',
      meta: {
        title: '自动清除策略',
      },
      component: () => import('/@/views/batch/auto-clean/index.vue'),
    },
    {
      path: '/batch/customer-center',
      name: 'BatchCustomerCenter',
      redirect: '/batch/customer-center/channel',
      meta: {
        title: '客户中心',
      },
    },
    {
      path: '/batch/customer-center/channel',
      name: 'BatchCustomerCenterChannel',
      meta: {
        title: '渠道管理',
      },
      component: () => import('/@/views/batch/customer-center/channel.vue'),
    },
    {
      path: '/batch/customer-center/customer',
      name: 'BatchCustomerCenterCustomer',
      meta: {
        title: '客户管理',
      },
      component: () => import('/@/views/batch/customer-center/customer.vue'),
    },
    {
      path: '/batch/customer-center/share-template',
      name: 'BatchCustomerCenterShareTemplate',
      meta: {
        title: '分享模板',
      },
      component: () => import('/@/views/batch/customer-center/share-template.vue'),
    },
    {
      path: '/batch/customer-center/convert-statistics',
      name: 'BatchCustomerCenterConvertStatistics',
      meta: {
        title: '转化统计',
      },
      component: () => import('/@/views/batch/customer-center/convert-statistics.vue'),
    },
    {
      path: '/batch/customer-center/hot-trend-management',
      name: 'BatchCustomerCenterHotTrendManagement',
      meta: {
        title: '热卖品管理',
      },
      component: () => import('/@/views/batch/customer-center/hot-trend-management.vue'),
    },
    {
      path: '/batch/index-space',
      name: 'BatchIndexSpace',
      meta: {
        title: '智能检索',
      },
      component: () => import('/@/views/batch/index-space/index.vue'),
    },
    {
      path: '/batch/index-space/upload-task',
      name: 'BatchIndexSpaceUploadTask',
      meta: {
        title: '智能检索-上传记录',
      },
      component: () => import('/@/views/batch/index-space/upload-task.vue'),
    },
    {
      path: '/batch/index-space/upload-task/:id',
      name: 'BatchIndexSpaceUploadTaskDetail',
      meta: {
        title: '智能检索-上传记录详情',
      },
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
      component: () => import('/@/views/batch/index-space/upload-task-detail.vue'),
    },

    {
      path: '/batch/video-articles',
      name: 'BatchVideoArticles',
      meta: {
        title: 'POD玩法精选',
      },
      component: () => import('/@/views/batch/video-articles/index.vue'),
    },

    {
      path: '/batch/download-center',
      name: 'DownloadCenter',
      meta: {
        title: '下载中心',
      },
      component: () => import('/@/views/batch/download-center/index.vue'),
    },
    {
      path: '/batch/store/home',
      name: 'BatchStoreHome',
      meta: {
        title: '店铺运营',
      },
      component: () => import('/@/views/batch/store/index.vue'),
    },
    {
      path: '/batch/search',
      name: 'BatchSearch',
      meta: {
        title: '印花图检索',
      },
      component: () => import('/@/views/batch/search/index.vue'),
    },
    {
      path: '/batch/search/task',
      name: 'BatchSearchTask',
      meta: {
        title: '印花图检索任务列表',
      },
      component: () => import('/@/views/batch/search/task.vue'),
    },
    {
      path: '/batch/token-grants',
      name: 'BatchTokenGrants',
      meta: {
        title: '应用授权',
      },
      component: () => import('/@/views/batch/token-grants/index.vue'),
    },
    {
      path: '/batch/search/task/cut-pieces/:id',
      redirect: ({ params }) => {
        return `/batch/cut-pieces-combine/${params.id}`;
      },
    },

    {
      path: '/batch/text',
      name: 'BatchText',
      meta: {
        title: '文生图',
      },
      component: () => import('/@/views/batch/text/index.vue'),
    },
    {
      path: '/batch/text/:id',
      name: 'BatchTextDetail',
      meta: {
        title: '文生图详情',
      },
      component: () => import('/@/views/batch/text/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: '/batch/image',
      name: 'BatchImage',
      meta: {
        title: '图裂变',
      },
      component: () => import('/@/views/batch/image.vue'),
    },
    {
      path: '/batch/image/:id',
      name: 'BatchImageDetail',
      meta: {
        title: '图裂变详情',
      },
      component: () => import('/@/views/batch/image-detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/product_fission',
      name: 'BatchProductFission',
      meta: {
        title: '商品图裂变',
      },
      component: () => import('/@/views/batch/product_fission/index.vue'),
    },
    {
      path: '/batch/product_fission/:id',
      name: 'BatchProductFissionDetail',
      meta: {
        title: '商品图裂变详情',
      },
      component: () => import('/@/views/batch/product_fission/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/polyptych',
      name: 'BatchPolyptych',
      meta: {
        title: '多联画',
      },
      component: () => import('/@/views/batch/polyptych/index.vue'),
    },
    {
      path: '/batch/polyptych/:id',
      name: 'BatchPolyptychDetail',
      meta: {
        title: '多联画详情',
      },
      component: () => import('/@/views/batch/polyptych/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/batch-image-processing',
      name: 'BatchBatchImageProcessing',
      meta: {
        title: '裁剪压缩',
      },
      component: () => import('/@/views/batch/batch-image-processing/index.vue'),
    },
    {
      path: '/batch/batch-image-processing/:id',
      name: 'BatchBatchImageProcessingDetail',
      meta: {
        title: '裁剪压缩详情',
      },
      component: () => import('/@/views/batch/batch-image-processing/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/title',
      name: 'BatchTitle',
      meta: {
        title: '标题提取',
      },
      component: () => import('/@/views/batch/title/index.vue'),
    },
    {
      path: '/batch/title/:id',
      name: 'BatchTitleDetail',
      meta: {
        title: '标题提取详情',
      },
      component: () => import('/@/views/batch/title/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/store/crawling',
      name: 'BatchStoreCrawling',
      meta: {
        title: '店铺采集',
      },
      component: () => import('/@/views/batch/crawling/craw-store/index.vue'),
    },
    {
      path: '/batch/crawling',
      name: 'BatchCrawling',
      meta: {
        title: '数据采集',
      },
      component: () => import('/@/views/batch/crawling/index.vue'),
    },
    {
      path: '/batch/crawling/:id',
      name: 'BatchCrawlingDetail',
      meta: {
        title: '数据采集详情',
      },
      component: () => import('/@/views/batch/crawling/detail.vue'),
    },

    {
      path: '/batch/detect',
      name: 'BatchDetect',
      meta: {
        title: '图案裁剪',
      },
      component: () => import('/@/views/batch/detect/index.vue'),
    },
    {
      path: '/batch/detect/:id',
      name: 'BatchDetectDetail',
      meta: {
        title: '图案裁剪详情',
      },
      component: () => import('/@/views/batch/detect/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/matting',
      name: 'BatchMatting',
      meta: {
        title: '一键抠图',
      },
      component: () => import('/@/views/batch/matting/index.vue'),
    },
    {
      path: '/batch/matting/:id',
      name: 'BatchMattingTask',
      meta: {
        title: '一键抠图详情',
      },
      component: () => import('/@/views/batch/matting/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: '/batch/mockup',
      name: 'BatchMockup',
      meta: {
        title: '套图模板',
      },
      component: () => import('/@/views/batch/mockup/index.vue'),
    },

    {
      path: '/batch/psd-parse',
      name: 'BatchMockupPSD',
      meta: {
        title: 'PSD解析',
      },
      component: () => import('/@/views/batch/mockup/_psd-test.vue'),
    },

    {
      path: '/batch/composite',
      name: 'BatchMockupComposite',
      meta: {
        title: '商品套图',
      },
      component: () => import('/@/views/batch/mockup/composite.vue'),
    },
    {
      path: '/batch/composite/:id',
      name: 'BatchMockupCompositeDetail',
      meta: {
        title: '商品套图详情',
      },
      component: () => import('/@/views/batch/mockup/composite-detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/dress',
      name: 'BatchDress',
      meta: {
        title: '模特试衣',
      },
      component: () => import('/@/views/batch/dress/index.vue'),
    },
    {
      path: '/batch/dress/:id',
      name: 'BatchDressDetail',
      meta: {
        title: '模特试衣详情',
      },
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
      component: () => import('/@/views/batch/dress/detail.vue'),
    },

    {
      path: '/batch/printing',
      name: 'BatchPrinting',
      meta: {
        title: '印花模板',
      },
      component: () => import('/@/views/batch/printing/index.vue'),
    },
    {
      path: '/batch/printing-composite',
      name: 'BatchPrintingComposite',
      meta: {
        title: '印花合成',
      },
      component: () => import('/@/views/batch/printing/composite.vue'),
    },
    {
      path: '/batch/printing-composite/:id',
      name: 'BatchPrintingCompositeDetail',
      meta: {
        title: '印花合成详情',
      },
      component: () => import('/@/views/batch/printing/composite-detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: '/batch/meme',
      name: 'BatchPrintingMeme',
      meta: {
        title: '梗图印花',
      },
      component: () => import('/@/views/batch/meme/index.vue'),
    },
    {
      path: '/batch/meme/:id',
      name: 'BatchPrintingMemeDetail',
      meta: {
        title: '梗图印花详情',
      },
      component: () => import('/@/views/batch/meme/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
          ability: MATERIAL_ABILITY.PRINTING_MEME,
          backPath: '/batch/meme',
        };
      },
    },

    {
      path: '/batch/seamless',
      name: 'BatchSeamless',
      meta: {
        title: '四方连续图',
      },
      component: () => import('/@/views/batch/seamless/index.vue'),
    },
    {
      path: '/batch/seamless/:id',
      name: 'BatchSeamlessDetail',
      meta: {
        title: '四方连续图详情',
      },
      component: () => import('/@/views/batch/seamless/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/redraw',
      name: 'BatchRedraw',
      meta: {
        title: '风格转绘',
      },
      component: () => import('/@/views/batch/redraw/index.vue'),
    },
    {
      path: '/batch/redraw/:id',
      name: 'BatchRedrawDetail',
      meta: {
        title: '风格转绘详情',
      },
      component: () => import('/@/views/batch/redraw/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/to3d',
      name: 'BatchTo3D',
      meta: {
        title: '风格转绘',
      },
      component: () => import('/@/views/batch/to3d/index.vue'),
    },
    {
      path: '/batch/to3d/:id',
      name: 'BatchTo3DDetail',
      meta: {
        title: '风格转绘详情',
      },
      component: () => import('/@/views/batch/to3d/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/task-center',
      name: 'BatchTaskCenter',
      meta: {
        title: '任务中心',
      },
      component: () => import('/@/views/batch/task-center/index.vue'),
    },

    {
      path: '/batch/video-publish',
      name: 'BatchVideoPublish',
      meta: {
        title: '视频发布',
      },
      component: () => import('/@/views/batch/video-publish/index.vue'),
    },

    {
      path: '/batch/video',
      name: 'BatchVideo',
      meta: {
        title: '视频生成',
      },
      component: () => import('/@/views/batch/video/index.vue'),
    },
    {
      path: '/batch/video/:id',
      name: 'BatchVideoDetail',
      meta: {
        title: '视频生成详情',
      },
      component: () => import('/@/views/batch/video/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/video-assets',
      name: 'BatchVideoAssets',
      meta: {
        title: '视频资产库',
      },
      component: () => import('/@/views/batch/video-assets/index.vue'),
    },

    {
      path: '/batch/video-cases',
      name: 'BatchVideoCases',
      meta: {
        title: '视频案例',
      },
      component: () => import('/@/views/batch/video-cases/index.vue'),
    },

    {
      path: '/batch/tiktok-account-authorization',
      name: 'BatchTiktokAccountAuthorization',
      meta: {
        title: 'Tiktok账号授权',
      },
      component: () => import('/@/views/batch/tiktok-account-authorization/index.vue'),
    },

    {
      path: '/batch/video-compose',
      name: 'BatchVideoCompose',
      meta: {
        title: '视频拼接',
      },
      component: () => import('/@/views/batch/video-compose/index.vue'),
    },
    {
      path: '/batch/video-compose/:id',
      name: 'BatchVideoComposeDetail',
      meta: {
        title: '视频拼接详情',
      },
      component: () => import('/@/views/batch/video-compose/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/image_processing',
      name: 'BatchImageProcessing',
      meta: {
        title: '商品裁剪压缩',
      },
      component: () => import('/@/views/batch/image_processing/index.vue'),
    },
    {
      path: '/batch/image_processing/:id',
      name: 'BatchImageProcessingDetail',
      meta: {
        title: '商品裁剪压缩详情',
      },
      component: () => import('/@/views/batch/image_processing/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/tiling',
      name: 'BatchTiling',
      meta: {
        title: '四方连续图拼接',
      },
      component: () => import('/@/views/batch/seamless/tiling.vue'),
    },

    {
      path: '/batch/tiling/:id',
      name: 'BatchTilingDetail',
      meta: {
        title: '四方连续图拼接详情',
      },
      component: () => import('/@/views/batch/seamless/tiling-detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/workflow',
      name: 'BatchWorkflow',
      meta: {
        title: '工作流',
      },
      component: () => import('/@/views/batch/workflow/index.vue'),
    },

    {
      path: '/batch/workflow/:id',
      name: 'BatchWorkflowDetail',
      meta: {
        title: '工作流详情',
      },
      component: () => import('/@/views/batch/workflow/detail.vue'),
    },

    {
      path: '/batch/workflow-template',
      name: 'BatchWorkflowTemplate',
      meta: {
        title: '工作流模板',
      },
      component: () => import('/@/views/batch/workflow-template/index.vue'),
    },

    {
      path: '/batch/workflow-template/:id?',
      name: 'BatchWorkflowTemplateDetail',
      meta: {
        title: '工作流模板详情',
      },
      component: () => import('/@/views/batch/workflow-template-detail/index.vue'),
    },
    {
      path: '/batch/img2print',
      name: 'BatchImageToPrint',
      meta: {
        title: '印花图提取',
      },
      component: () => import('/@/views/batch/image-to-print/index.vue'),
    },
    {
      path: '/batch/img2print/:id',
      name: 'BatchImageToPrintDetail',
      meta: {
        title: '印花图提取详情',
      },
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
      component: () => import('/@/views/batch/image-to-print/detail.vue'),
    },

    {
      path: '/batch/blend',
      name: 'BatchBlend',
      meta: {
        title: '元素融合',
      },
      component: () => import('/@/views/batch/blend/index.vue'),
    },
    {
      path: '/batch/blend/:id',
      name: 'BatchBlendDetail',
      meta: {
        title: '元素融合详情',
      },
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
      component: () => import('/@/views/batch/blend/detail.vue'),
    },

    {
      path: '/batch/part-replace',
      name: 'BatchPartReplace',
      meta: {
        title: '全能改图',
      },
      component: () => import('/@/views/batch/part-replace/index.vue'),
    },
    {
      path: '/batch/part-replace/:id',
      name: 'BatchPartReplaceDetail',
      meta: {
        title: '全能改图详情',
      },
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
      component: () => import('/@/views/batch/part-replace/detail.vue'),
    },

    {
      path: '/batch/multi-size',
      name: 'BatchMultiSize',
      meta: {
        title: '尺寸延展',
      },
      component: () => import('/@/views/batch/multi-size/index.vue'),
    },
    {
      path: '/batch/multi-size/:id',
      name: 'BatchMultiSizeDetail',
      meta: {
        title: '尺寸延展详情',
      },
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
      component: () => import('/@/views/batch/multi-size/detail.vue'),
    },

    {
      path: '/batch/tk-video',
      name: 'BatchTKVideo',
      meta: {
        title: 'TK视频生成',
      },
      component: () => import('/@/views/batch/tk-video/index.vue'),
    },
    {
      path: '/batch/tk-video/:id',
      name: 'BatchTKVideoDetail',
      meta: {
        title: 'TK视频生成详情',
      },
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
      component: () => import('/@/views/batch/tk-video/detail.vue'),
    },

    {
      path: '/batch/image-search',
      name: 'BatchImageSearch',
      meta: {
        title: '以图搜图',
      },
      component: () => import('/@/views/batch/image-search/index.vue'),
    },

    {
      path: '/batch/hot-trend',
      name: 'BatchHotTrend',
      meta: {
        title: '热卖趋势',
      },
      component: () => import('/@/views/batch/hot-trend/index.vue'),
    },

    {
      path: '/batch/tools',
      name: 'BatchTools',
      meta: {
        title: '全部工具',
      },
      component: () => import('/@/views/batch/tools/index.vue'),
    },

    {
      path: '/batch/style-reference',
      name: 'BatchStyleReference',
      meta: {
        title: '风格参考',
      },
      component: () => import('/@/views/batch/style-reference/index.vue'),
    },
    {
      path: '/batch/style-reference/:id',
      name: 'BatchStyleReferenceDetail',
      meta: {
        title: '风格参考详情',
      },
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
      component: () => import('/@/views/batch/style-reference/detail.vue'),
    },

    {
      path: '/batch/svg',
      name: 'BatchSvg',
      meta: {
        title: '转矢量图',
      },
      component: () => import('/@/views/batch/svg/index.vue'),
    },
    {
      path: '/batch/svg/:id',
      name: 'BatchSvgDetail',
      meta: {
        title: '转矢量图详情',
      },
      component: () => import('/@/views/batch/svg/detail.vue'),
    },

    {
      path: '/batch/editor',
      name: 'BatchImageEditing',
      meta: {
        title: '批量编辑',
      },
      component: () => import('/@/views/batch/image-editing/index.vue'),
    },
    {
      path: '/batch/editor/:id',
      name: 'BatchImageEditingDetail',
      meta: {
        title: '批量编辑详情',
      },
      component: () => import('/@/views/batch/image-editing/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/expand',
      name: 'BatchExpand',
      meta: {
        title: '扩图',
      },
      component: () => import('/@/views/batch/expand/index.vue'),
    },
    {
      path: '/batch/expand/:id',
      name: 'BatchExpandDetail',
      meta: {
        title: '扩图详情',
      },
      component: () => import('/@/views/batch/expand/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/watermark',
      name: 'BatchWatermark',
      meta: {
        title: '去水印',
      },
      component: () => import('/@/views/batch/watermark/index.vue'),
    },
    {
      path: '/batch/watermark/:id',
      name: 'BatchWatermarkDetail',
      meta: {
        title: '去水印详情',
      },
      component: () => import('/@/views/batch/watermark/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/upscale',
      name: 'BatchUpscale',
      meta: {
        title: '超分提质',
      },
      component: () => import('/@/views/batch/upscale/index.vue'),
    },
    {
      path: '/batch/upscale/:id',
      name: 'BatchUpscaleDetail',
      meta: {
        title: '超分提质详情',
      },
      component: () => import('/@/views/batch/upscale/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/tort',
      name: 'BatchTort',
      meta: {
        title: '侵权风险过滤',
      },
      component: () => import('/@/views/batch/tort/index.vue'),
    },
    {
      path: '/batch/tort/:id',
      name: 'BatchTortDetail',
      meta: {
        title: '侵权风险过滤详情',
      },
      component: () => import('/@/views/batch/tort/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: '/batch/color-change',
      name: 'BatchColorChange',
      meta: {
        title: '多配色',
      },
      component: () => import('/@/views/batch/color-change/index.vue'),
    },
    {
      path: '/batch/color-change/:id',
      name: 'BatchColorChangeDetail',
      meta: {
        title: '多配色详情',
      },
      component: () => import('/@/views/batch/color-change/detail.vue'),
    },

    {
      path: '/batch/remove',
      name: 'BatchRemove',
      meta: {
        title: '智能擦除',
      },
      component: () => import('/@/views/batch/remove/index.vue'),
    },
    {
      path: '/batch/remove/:id',
      name: 'BatchRemoveDetail',
      meta: {
        title: '智能擦除详情',
      },
      component: () => import('/@/views/batch/remove/detail.vue'),
    },

    {
      path: '/batch/font',
      name: 'BatchFont',
      meta: {
        title: '字体管理',
      },
      component: () => import('/@/views/batch/font/index.vue'),
    },

    {
      path: '/batch/export-template',
      name: 'BatchExportTemplate',
      meta: {
        title: '导出模板',
      },
      component: () => import('/@/views/batch/export-template/index.vue'),
    },
    {
      path: '/batch/wordbook',
      name: 'BatchWordbook',
      meta: {
        title: '关键词词库',
      },
      component: () => import('/@/views/batch/wordbook/index.vue'),
    },
    {
      path: '/batch/wordbook/:id',
      name: 'BatchWordbookDetail',
      meta: {
        title: '关键词词库',
      },
      component: () => import('/@/views/batch/wordbook/detail.vue'),
    },

    {
      path: '/batch/cut-pieces',
      name: 'BatchCutPieces',
      meta: {
        title: '裁片图模板',
      },
      component: () => import('/@/views/batch/cut-pieces/index.vue'),
    },
    {
      path: '/batch/cut-pieces-combine',
      name: 'BatchCutPiecesCombine',
      meta: {
        title: '裁片图合成任务列表',
      },
      component: () => import('/@/views/batch/cut-pieces/combine.vue'),
    },
    {
      path: '/batch/cut-pieces/:id',
      redirect: ({ params }) => {
        return `/batch/cut-pieces-combine/${params.id}`;
      },
    },
    {
      path: '/batch/cut-pieces-combine/:id',
      name: 'BatchSCutPiecesDetail',
      meta: {
        title: '裁片图合成详情',
      },
      component: () => import('/@/views/batch/cut-pieces/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
          mode: 'cutPieces',
        };
      },
    },

    {
      path: '/batch/cut-pieces-extraction',
      name: 'BatchCutPiecesExtraction',
      meta: {
        title: '裁片图提取任务列表',
      },
      component: () => import('/@/views/batch/cut-pieces-extraction/index.vue'),
    },
    {
      path: '/batch/cut-pieces-extraction/:id',
      name: 'BatchCutPiecesExtractionDetail',
      meta: {
        title: '裁片图提取详情',
      },
      component: () => import('/@/views/batch/cut-pieces-extraction/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: 'member',
      name: 'BatchMember',
      meta: {
        title: '成员管理',
      },
      props() {
        return {
          inviteUrlQuery: 'toCreation=3',
        };
      },
      component: () => import('/@/views/member/index.vue'),
    },
    {
      path: 'account',
      name: 'BatchAccount',
      meta: {
        title: '账号中心',
      },
      component: () => import('/@/views/account/index.vue'),
    },
    {
      path: 'lingdou',
      name: 'BatchLingdou',
      meta: {
        title: '灵豆记录',
      },
      component: () => import('/@/views/batch/commerce/lingdou/index.vue'),
    },
    {
      path: 'user',
      name: 'BatchUser',
      meta: {
        title: '个人信息管理',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/user/index.vue'),
    },
    {
      path: 'team',
      name: 'BatchTeam',
      meta: {
        title: '团队信息管理',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/batch/team/index.vue'),
    },
    {
      path: 'commerce',
      name: 'BatchCommerce',
      meta: {
        title: '订单发票',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/batch/commerce/index.vue'),
      children: [
        {
          path: 'order',
          name: 'BatchOrder',
          meta: {
            title: '订单',
            ignoreKeepAlive: false,
            hideMenu: true,
          },
          component: () => import('/@/views/batch/commerce/order/index.vue'),
        },
        {
          path: 'invoice',
          name: 'BatchInvoice',
          meta: {
            title: '发票',
            ignoreKeepAlive: false,
            hideMenu: true,
          },
          component: () => import('/@/views/batch/commerce/invoice/index.vue'),
        },
      ],
    },
    {
      path: 'order/:tradeNo',
      name: 'BatchOrderDetail',
      meta: {
        title: '订单详情',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/batch/commerce/order-detail/index.vue'),
    },
    {
      path: 'invoice/:tradeNo',
      name: 'BatchInvoiceDetail',
      meta: {
        title: '发票详情',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/batch/commerce/invoice-detail/index.vue'),
    },

    {
      path: 'shelf/goods',
      name: 'BatchShelfGoods',
      meta: {
        title: '商品库',
      },
      component: () => import('/@/views/batch/shelf/goods/index.vue'),
    },
    {
      path: 'shelf/goods/task',
      name: 'BatchShelfGoodsTask',
      meta: {
        title: '商品库任务列表',
      },
      component: () => import('/@/views/batch/shelf/goods-task/index.vue'),
    },
    {
      path: 'shelf/goods/task/title/:id',
      name: 'BatchShelfGoodsTaskTitleDetail',
      meta: {
        title: '标题提取详情',
      },
      component: () => import('/@/views/batch/shelf/goods-task-detail/title.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: 'shelf/goods/task/tort/:id',
      name: 'BatchShelfGoodsTaskTortDetail',
      meta: {
        title: '侵权风险过滤详情',
      },
      component: () => import('/@/views/batch/shelf/goods-task-detail/tort.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: 'shelf/goods/task/watermark/:id',
      name: 'BatchShelfGoodsTaskWatermarkDetail',
      meta: {
        title: '去水印',
      },
      component: () => import('/@/views/batch/shelf/goods-task-detail/watermark.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: 'shelf/goods/task/img2Print/:id',
      name: 'BatchShelfGoodsTaskImg2PrintDetail',
      meta: {
        title: '印花图提取详情',
      },
      component: () => import('/@/views/batch/shelf/goods-task-detail/image_to_print.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: 'shelf/goods/task/change_background_new/:id',
      name: 'BatchShelfGoodsTaskChangeBackgroundNewDetail',
      meta: {
        title: '换背景详情',
      },
      component: () => import('/@/views/batch/shelf/goods-task-detail/change_background_new.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: 'shelf/goods/task/detect/:id',
      name: 'BatchShelfGoodsTaskDetectDetail',
      meta: {
        title: '图案裁剪详情',
      },
      component: () => import('/@/views/batch/shelf/goods-task-detail/detect.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: 'shelf/goods/task/production/:id',
      name: 'BatchShelfGoodsTaskProductionDetail',
      meta: {
        title: '生产图详情',
      },
      component: () => import('/@/views/batch/shelf/goods-task-detail/production.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: 'shelf/goods/task/image_processing/:id',
      name: 'BatchShelfGoodsTaskImageProcessingDetail',
      meta: {
        title: '商品裁剪压缩详情',
      },
      component: () => import('/@/views/batch/shelf/goods-task-detail/image_processing.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: 'shelf/goods/task/cut-pieces/:id',
      name: 'BatchShelfGoodsTaskCutPiecesDetail',
      meta: {
        title: '裁片图合成详情',
      },
      component: () => import('/@/views/batch/cut-pieces/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
          mode: 'goods',
        };
      },
    },
    {
      path: 'shelf/goods/:id',
      name: 'BatchShelfGoodsDetail',
      meta: {
        title: '商品详情',
      },
      component: () => import('/@/views/batch/shelf/goods-detail/index.vue'),
      props(route) {
        return {
          id: route.params.id,
        };
      },
    },
    {
      path: 'shelf/shop',
      name: 'BatchShelfShop',
      meta: {
        title: '店铺管理',
      },
      component: () => import('/@/views/batch/shelf/shop/index.vue'),
    },
    {
      path: 'shelf/template',
      name: 'BatchShelfTemplate',
      meta: {
        title: '刊登模板',
      },
      component: () => import('/@/views/batch/shelf/template/index.vue'),
    },
    {
      path: 'shelf/goods/publish/task',
      name: 'BatchShelfGoodsPublishTask',
      meta: {
        title: '刊登任务',
      },
      component: () => import('/@/views/batch/shelf/goods-publish-task/index.vue'),
    },
    {
      path: 'shelf/goods/publish/task/:id',
      name: 'BatchShelfGoodsPublishTaskDetail',
      meta: {
        title: '刊登任务详情',
      },
      component: () => import('/@/views/batch/shelf/goods-publish-task/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: '/batch/shelf/order-management',
      name: 'BatchShelfOrderManagement',
      meta: {
        title: '订单处理',
      },
      component: () => import('/@/views/batch/shelf/order-management/index.vue'),
    },
    {
      path: '/batch/shelf/order-management/push-record',
      name: 'BatchShelfOrderManagementPushRecord',
      meta: {
        title: '推送记录',
      },
      component: () => import('/@/views/batch/shelf/order-management/push-record/index.vue'),
    },
    {
      path: '/batch/shelf/order-management/diy-task-auto',
      name: 'BatchShelfOrderManagementDiyTaskAuto',
      meta: {
        title: '履约自动化',
      },
      component: () => import('/@/views/batch/shelf/order-management/diy-task-auto/index.vue'),
    },
    {
      path: '/batch/shelf/order-management/push-detail/:id',
      name: 'BatchShelfOrderManagementPushDetail',
      meta: {
        title: '推送详情',
      },
      component: () => import('/@/views/batch/shelf/order-management/push-detail/index.vue'),
      props(route) {
        return {
          id: route.params.id,
        };
      },
    },
    {
      path: '/batch/diy/template',
      name: 'BatchDIYTemplate',
      meta: {
        title: '来图定制模板',
      },
      component: () => import('/@/views/batch/diy/templates/index.vue'),
    },
    {
      path: '/batch/diy/compositing',
      name: 'BatchDIYCompositing',
      meta: {
        title: '图片合成',
      },
      component: () => import('/@/views/batch/diy/compositing/index.vue'),
    },
    {
      path: '/batch/diy/compositing/:id',
      name: 'BatchDIYCompositingDetail',
      meta: {
        title: '图片合成详情',
      },
      component: () => import('/@/views/batch/diy/compositing/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/diy/fulfillment',
      name: 'BatchDIYFulfillment',
      meta: {
        title: 'DIY履约合成',
      },
      component: () => import('/@/views/batch/diy/fulfillment/index.vue'),
    },
    {
      path: '/batch/diy/fulfillment/:id',
      name: 'BatchDIYFulfillmentDetail',
      meta: {
        title: 'DIY履约合成详情',
      },
      component: () => import('/@/views/batch/diy/fulfillment/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: '/batch/vector-templates',
      name: 'BatchDIYVectorTemplates',
      meta: {
        title: '履约矢量模板',
      },
      component: () => import('/@/views/batch/vector-diy/templates.vue'),
    },
    {
      path: '/batch/vector-compositing',
      name: 'BatchDIYVectorCompositing',
      meta: {
        title: '履约矢量合成',
      },
      component: () => import('/@/views/batch/vector-diy/index.vue'),
    },
    {
      path: '/batch/vector-compositing/:id',
      name: 'BatchDIYVectorCompositingDetail',
      meta: {
        title: '履约矢量合成详情',
      },
      component: () => import('/@/views/batch/vector-diy/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/pet_dressup',
      name: 'BatchPetDressup',
      meta: {
        title: '宠物换装',
      },
      component: () => import('/@/views/batch/pet-dressup/index.vue'),
    },
    {
      path: '/batch/pet_dressup/:id',
      name: 'BatchPetDressupDetail',
      meta: {
        title: '宠物换装详情',
      },
      component: () => import('/@/views/batch/pet-dressup/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/group_photo',
      name: 'BatchGroupPhoto',
      meta: {
        title: '合照',
      },
      component: () => import('/@/views/batch/group-photo/index.vue'),
    },
    {
      path: '/batch/group_photo/:id',
      name: 'BatchGroupPhotoDetail',
      meta: {
        title: '合照详情',
      },
      component: () => import('/@/views/batch/group-photo/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/uv_layering',
      name: 'BatchUVLayering',
      meta: {
        title: '智能分图层',
      },
      component: () => import('/@/views/batch/uv-layering/index.vue'),
    },
    {
      path: '/batch/uv_layering/:id',
      name: 'BatchUVLayeringDetail',
      meta: {
        title: '智能分图层详情',
      },
      component: () => import('/@/views/batch/uv-layering/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/smart-layout',
      name: 'BatchSmartLayout',
      meta: {
        title: '智能排版',
      },
      component: () => import('/@/views/batch/smart-layout/index.vue'),
    },
    {
      path: '/batch/smart-layout/:id',
      name: 'BatchSmartLayoutDetail',
      meta: {
        title: '智能排版详情',
      },
      component: () => import('/@/views/batch/smart-layout/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/smart_mockup',
      name: 'BatchSmartMockup',
      meta: {
        title: '一键套图',
      },
      component: () => import('/@/views/batch/smart-mockup/index.vue'),
    },
    {
      path: '/batch/smart_mockup/:id',
      name: 'BatchSmartMockupDetail',
      meta: {
        title: '一键套图详情',
      },
      component: () => import('/@/views/batch/smart-mockup/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },

    {
      path: '/batch/change_background_new',
      name: 'BatchChangeBackgroundNew',
      meta: {
        title: '换背景',
      },
      component: () => import('/@/views/batch/change_background_new/index.vue'),
    },
    {
      path: '/batch/change_background_new/:id',
      name: 'BatchChangeBackgroundNewDetail',
      meta: {
        title: '换背景详情',
      },
      component: () => import('/@/views/batch/change_background_new/detail.vue'),
      props(route) {
        return {
          taskId: route.params.id,
        };
      },
    },
    {
      path: '/batch/pricing',
      name: 'BatchPricing',
      meta: {
        title: '套餐&定价',
      },
      component: () => import('/@/views/batch/pricing/index.vue'),
      props(route) {
        return {};
      },
    },
  ],
};

export default batch;
